import { Position, StateObj } from 'src/types'
import { indexFingerCover } from 'src/features/brands/treasure/canvas/glove/back/fingerCoverOrPad/indexFingerCover'
import { indexFingerCoverTipOut } from 'src/features/brands/treasure/canvas/glove/back/fingerCoverOrPad/indexFingerCoverTipOut'
import { indexFingerPadWithNoEdge } from 'src/features/brands/treasure/canvas/glove/back/fingerCoverOrPad/indexFingerPadWithNoEdge'
import { middleFingerCover } from 'src/features/brands/treasure/canvas/glove/back/fingerCoverOrPad/middleFIngerCover'
import { middleFingerPadWithNoEdge } from 'src/features/brands/treasure/canvas/glove/back/fingerCoverOrPad/middleFingerPadWithNoEdge'

export const fingerCoverDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerGuardType: StateObj,
  position: Position,
  indexCoverColor: string,
  stitchColor: string
): void => {
  const isIndexFingerCover = fingerGuardType?.value == 'indexCover' || (fingerGuardType?.value === 'unselected' && position === 'pitcher')
  const isIndexFingerCoverTipOut = fingerGuardType?.value === 'indexTipOutCover'
  const isIndexFingerPadWithNoEdge = fingerGuardType?.value === 'indexPadWithNoEdge'
  const isMiddleFingerCover = fingerGuardType?.value === 'middleCover'
  const isMiddleFingerPadWithNoEdge = fingerGuardType?.value === 'middlePadWithNoEdge'
  const isMiddleFingerCoverTipOut = fingerGuardType?.value === 'middleTipOutCover'
  const isIndexAndMiddleFingerTipOutCover = fingerGuardType?.value === 'indexAndMiddleTipOutCover'

  isIndexFingerCover && indexFingerCover(ctx, indexCoverColor, stitchColor)
  // 指カバー(中指)
  isMiddleFingerCover && middleFingerCover(ctx, indexCoverColor, stitchColor, -140, 65, -10)
  // 指カバー＿先出し
  isIndexFingerCoverTipOut && indexFingerCoverTipOut(ctx, indexCoverColor, stitchColor, 0, 0, 0)
  // ヘリ無し指アテ
  isIndexFingerPadWithNoEdge && indexFingerPadWithNoEdge(ctx, indexCoverColor, stitchColor)
  isMiddleFingerPadWithNoEdge && middleFingerPadWithNoEdge(ctx, indexCoverColor, stitchColor, -165, 90, -15)
  isMiddleFingerCoverTipOut && indexFingerCoverTipOut(ctx, indexCoverColor, stitchColor, -165, 90, -15)
  isIndexAndMiddleFingerTipOutCover && indexFingerCoverTipOut(ctx, indexCoverColor, stitchColor, -90, 70, -10)
}
